import React, { useEffect, useRef, useState } from 'react'
import TitleWithBackNavigation from '../../../../components/TitleWithBackNavigation'
import { Checkbox, Collapse, Row, Col, Button, Input, Modal } from 'antd'
import { useDispatch, useSelector } from 'react-redux'
import { ApiCaller, Colors } from '../../../../config'
import { useMutation } from 'react-query'
import { setError, setMessage } from '../../../../store/common/generalSlice'
import { useNavigate } from 'react-router-dom'
import { fetchProfileData } from '../../../../store/common/settingSlice'
import { getStructuredServices, updateSelectionStructure, updateSingleThirdLayerSelection } from '../../../../config/utils'

const AddServices = () => {

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const servicesTrack = useRef(null);

    const [defaultActiveCollapseKeys, setDefaultActiveCollapseKeys] = useState(null)
    const [currentActiveCollapseKey, setCurrentActiveCollapseKey] = useState('');
    const [allServices, setAllServices] = useState([]);
    const [isError, setIsError] = useState(false);
    const [preserveStructure, setPreserveStructure] = useState([]);

    const [selectedServices, setSelectedServices] = useState({})
    const [selectedFinalServices, setSelectedFinalServices] = useState({});


    // need only in case of edit
    const [isDisabled, setIsDisabled] = useState(true);

    const { loading: servicesLoading, services, selectedService } = useSelector(state => state?.services);
    const { profileData } = useSelector(state => state?.setting);

    useEffect(() => {
        if (selectedService) {
            let listedServices = selectedService?.map((service) => {
                return (
                    {
                        name: service?.name,
                        percentage: service?.percentage,
                        firstParentId: service?.id,
                        subServices: service?.subServices?.length > 0 ?
                            service?.subServices?.map((subService) => {
                                return (
                                    {
                                        name: subService?.name,
                                        secondParentId: subService?.id,
                                        percentage: subService?.percentage,
                                        subServices: subService?.subServices?.length > 0 ?
                                            subService?.subServices?.map((service) => {
                                                return (
                                                    {
                                                        id: service?.id,
                                                        name: service?.name,
                                                        percentage: service?.percentage
                                                    }
                                                )
                                            })
                                            : []
                                    }
                                )
                            })
                            : []
                    }
                )
            })

            let tempObjectOfFirstParent = {};
            let tempObjectOfSecondParent = {};
            let defaultActiveKeyIds = []

            for (const element of selectedService) {
                tempObjectOfFirstParent[element?.id] = [];
                tempObjectOfSecondParent[element?.id] = [];
            }

            if (profileData && profileData?.userServices?.length > 0) {
                let tempFirstParentKeys = Object.keys(tempObjectOfFirstParent);

                profileData?.userServices.map((item) => {
                    // case 1 if parentId is null that means the object item belongs to the first layer.
                    if (item?.service?.parentId == null) {
                        let defaultKey = defaultActiveKeyIds?.find((defaultKey) => defaultKey == item?.service?.id);
                        if (!defaultKey) {
                            defaultActiveKeyIds.push(item?.service?.id)
                        }

                        let isParentExist = tempObjectOfSecondParent[item?.service?.id]?.filter((subItem) => {
                            return subItem?.serviceId == item?.service?.id
                        });

                        // if (isParentExist?.length > 0) {
                        //     tempObjectOfSecondParent[item?.service?.id] = [...tempObjectOfSecondParent[item?.service?.id]]
                        // }

                        if (isParentExist?.length == 0) {
                            tempObjectOfSecondParent[item?.service?.id] =
                                [...tempObjectOfSecondParent[item?.service?.id], { serviceId: Number(item?.service?.id), details: item?.userServicePrice ? item?.userServicePrice : null }]
                        }

                    }
                    if (item?.userServicePrice !== null) {
                        let extraDetailModalCloneData = { ...extraDetailModal.data };
                        if (item?.service?.id && !extraDetailModalCloneData[item?.service?.id]) {
                            setExtraDetailModal((prev) =>
                            ({
                                ...prev, data: {
                                    ...prev?.data,
                                    [item?.service?.id]: {
                                        cars: item?.userServicePrice?.cars,
                                        vans: item?.userServicePrice?.vans,
                                        price: item?.userServicePrice?.price
                                    }
                                }
                            }))
                        }
                    }
                    if (item?.service?.parentId !== null) {

                        let key = tempFirstParentKeys?.find((keyItem) => keyItem == item?.service?.parentId);
                        let childKey = item?.service?.id;

                        if (!key) {
                            // if !key that means the parentId is actually an id of secondLayer parent.
                            let listing = [];
                            outerLoop:
                            for (let service of listedServices) {
                                if (service?.subServices?.length > 0) {
                                    for (let subItem of service.subServices) {
                                        if (subItem?.secondParentId == item?.service?.parentId) {
                                            listing.push(service);
                                            break outerLoop;
                                        }
                                    }
                                }
                            }

                            if (listing?.length > 0) {
                                let tempObj = listing[0];
                                let firstParentId = tempObj?.firstParentId;
                                let isParentExist = tempObjectOfSecondParent[firstParentId]?.filter((subItem) => {
                                    return subItem?.serviceId == item?.service?.parentId
                                });

                                let isChildExist = tempObjectOfFirstParent[firstParentId]?.filter((subItem) => {
                                    return subItem == item?.service?.id
                                });

                                // if (isParentExist?.length > 0) {
                                //     tempObjectOfSecondParent[firstParentId] = [...tempObjectOfSecondParent[firstParentId]]
                                // }

                                if (isParentExist?.length == 0) {
                                    tempObjectOfSecondParent[firstParentId] =
                                        [...tempObjectOfSecondParent[firstParentId], { serviceId: Number(item?.service?.parentId), details: item?.userServicePrice ? item?.userServicePrice : null }]
                                }

                                // if (isChildExist?.length > 0) {
                                //     tempObjectOfFirstParent[firstParentId] = [...tempObjectOfFirstParent[firstParentId]];
                                // }

                                if (isChildExist?.length == 0) {
                                    tempObjectOfFirstParent[firstParentId] =
                                        [...tempObjectOfFirstParent[firstParentId], item?.service?.id]
                                }
                            }
                        }

                        else {
                            let defaultKey = defaultActiveKeyIds?.find((defaultKey) => defaultKey == key);
                            if (!defaultKey) {
                                defaultActiveKeyIds.push(key)
                            }

                            let isParentExist = tempObjectOfSecondParent[key]?.filter((item) => {
                                return item?.serviceId == key
                            });

                            let isChildExist = tempObjectOfSecondParent[key]?.filter((item) => {
                                return item?.serviceId == childKey
                            });

                            // if (isParentExist?.length > 0) {
                            //     tempObjectOfSecondParent[key] = [...tempObjectOfSecondParent[key]]
                            // }

                            if (isParentExist?.length == 0) {
                                tempObjectOfSecondParent[key] =
                                    [...tempObjectOfSecondParent[key], { serviceId: Number(key), details: item?.userServicePrice ? item?.userServicePrice : null }]
                            }

                            // if (isChildExist?.length > 0) {
                            //     tempObjectOfSecondParent[key] = [...tempObjectOfSecondParent[key]];
                            // }

                            if (isChildExist?.length == 0) {
                                tempObjectOfSecondParent[key] =
                                    [...tempObjectOfSecondParent[key], { serviceId: Number(childKey), details: item?.userServicePrice ? item?.userServicePrice : null }]
                            }
                        }
                    }
                })

                // setDefaultActiveCollapseKeys(defaultActiveKeyIds)
            }

            setDefaultActiveCollapseKeys([selectedService[0]?.id])
            setSelectedServices(tempObjectOfFirstParent)
            setAllServices(listedServices)
            setSelectedFinalServices(tempObjectOfSecondParent)
            setPreserveStructure(profileData?.userServices)
        }
    }, [selectedService])


    const [extraDetailModal, setExtraDetailModal] = useState({
        show: false,
        data: {},
        error: {
            checkboxError: "",
            priceError: ""
        }
    });

    const handleCheckAll = (firstParentId, subService, checked) => {
        // a case for edit only
        // if (profileData?.userServices?.length > 0 && !isDisabled.isServicesDirty) {
        //     setIsDisabled({ ...isDisabled, isServicesDirty: true })
        // }
        // Update selected services
        setSelectedServices((prev) => {
            const currentSelected = prev[firstParentId] || [];
            const subServiceIds = subService?.subServices?.map(s => s.id) || [];

            // Update selected services based on whether checked or not
            const updatedSelected = checked
                ? [...new Set([...currentSelected, ...subServiceIds])]
                : currentSelected.filter(id => !subServiceIds.includes(id));

            return {
                ...prev,
                [firstParentId]: updatedSelected,
            };
        });

        // Update selected final services
        setSelectedFinalServices((prevFinalServices) => {
            const updatedFinalServices = { ...prevFinalServices };
            const service = updatedFinalServices[firstParentId] || [];

            // Ensure firstParentId exists
            if (!service.some(item => item?.serviceId === firstParentId)) {
                updatedFinalServices[firstParentId] = [
                    ...service,
                    { serviceId: firstParentId, details: null }
                ];
            }

            // Handle second layer of parent (if it exists)
            const secondParentId = subService?.secondParentId; // Directly access secondParentId

            if (secondParentId) {
                // Update second parent services based on check
                if (checked) {
                    // Add the second parent if checked
                    if (!service.some(item => item?.serviceId === secondParentId)) {
                        updatedFinalServices[firstParentId].push({
                            serviceId: secondParentId,
                            details: null
                        });
                    }
                } else {
                    // If unchecked, remove the second parent
                    updatedFinalServices[firstParentId] = updatedFinalServices[firstParentId].filter(
                        item => item.serviceId !== secondParentId
                    );
                }
            }

            // Check if the firstParentId needs to be updated
            if (!checked) {
                // Check if there are any remaining secondParentIds associated with firstParentId
                const hasRemainingSecondParents = updatedFinalServices[firstParentId].some(item => item.serviceId !== firstParentId);
                if (!hasRemainingSecondParents) {
                    // If no secondParentIds are left, set firstParentId to an empty array instead of deleting it
                    updatedFinalServices[firstParentId] = [];
                }
            }

            return updatedFinalServices;
        });

        let updatedStructure = [...preserveStructure];

        if (!checked && updatedStructure?.length > 0) {
            updatedStructure = updatedStructure.filter((structure) => {
                const isSecondLevelMatch = structure?.service?.id == subService?.secondParentId;
                const isFirstLevelMatch = structure?.service?.id == firstParentId;
                const isThirdLevelMatch =
                    subService?.subServices?.some(
                        (thirdService) => thirdService?.id == structure?.service?.id
                    );

                return !(
                    isSecondLevelMatch || isFirstLevelMatch || isThirdLevelMatch
                );
            });
        }

        setPreserveStructure(updatedStructure)
        setIsDisabled(false)
    };

    const handleSubServiceCheck = (service, thirdLayerSubService, subService, checked) => {
        const { name, firstParentId } = service;
        const secondParentId = subService?.secondParentId;

        // a case for edit only
        // if (profileData?.userServices?.length > 0 && !isDisabled.isServicesDirty) {
        //     setIsDisabled({ ...isDisabled, isServicesDirty: true })
        // }

        // Update selectedServices for individual sub-service check
        setSelectedServices((prev) => {
            const currentSelected = prev[firstParentId] || [];
            console.log(currentSelected)
            const updatedSelected = checked
                ? [...new Set([...currentSelected, thirdLayerSubService.id])]
                : currentSelected.filter(id => id !== thirdLayerSubService.id);

            return {
                ...prev,
                [firstParentId]: updatedSelected,
            };
        });

        // Update selectedFinalServices for both firstParentId and secondParentId
        setSelectedFinalServices((prevFinalServices) => {
            let updatedFinalServices = { ...prevFinalServices };

            // Ensure firstParentId exists in updatedFinalServices
            if (!updatedFinalServices[firstParentId]) {
                updatedFinalServices[firstParentId] = [];
            }

            // Handle second layer (secondParentId)
            if (secondParentId) {
                let firstService = updatedFinalServices[firstParentId];

                // Add both firstParentId and secondParentId when checked
                if (checked) {
                    const firstParentExists = firstService.some(item => item?.serviceId === firstParentId);
                    if (!firstParentExists) {
                        firstService.push({ serviceId: firstParentId, details: null });
                    }

                    const secondParentExists = firstService.some(item => item?.serviceId === secondParentId);
                    if (!secondParentExists) {
                        firstService.push({ serviceId: secondParentId, details: null });
                    }
                } else {
                    // On uncheck, check for remaining third-layer IDs
                    const remainingThirdLayerIds = selectedServices[firstParentId]?.filter(id => id !== thirdLayerSubService.id);

                    // Update the selectedServices state
                    setSelectedServices((prev) => ({
                        ...prev,
                        [firstParentId]: remainingThirdLayerIds,
                    }));

                    // Check if there are any remaining third-layer IDs associated with the secondParentId
                    const secondLayerSubServices = allServices.find(s => s.firstParentId === firstParentId)?.subServices || [];
                    const hasRemainingThirdLayerForSecondParent = secondLayerSubServices
                        .find(sub => sub.secondParentId === secondParentId)?.subServices
                        .some(thirdSub => remainingThirdLayerIds.includes(thirdSub.id));

                    // If no remaining third-layer IDs for the secondParentId, remove it from finalServices
                    if (!hasRemainingThirdLayerForSecondParent) {
                        updatedFinalServices[firstParentId] = updatedFinalServices[firstParentId].filter(
                            item => item.serviceId !== secondParentId
                        );
                    }

                    // Now check if we need to clear the array for the firstParentId
                    const hasRemainingThirdLayersForFirstParent = remainingThirdLayerIds.length > 0;

                    // If no remaining third-layer IDs exist for firstParentId, empty its array instead of removing the property
                    if (!hasRemainingThirdLayersForFirstParent) {
                        updatedFinalServices[firstParentId] = [];
                    } else if (updatedFinalServices[firstParentId]?.length === 0) {
                        updatedFinalServices[firstParentId] = [];
                    }
                }
            }

            return updatedFinalServices;
        });

        const updatedStructure = [...preserveStructure];
        if (!checked && updatedStructure?.length > 0) {
            const item = updatedStructure?.find(updatedService => updatedService?.service?.id == thirdLayerSubService?.id);
            if (item && item !== undefined) {
                let count = 0;
                // const servicesIndexes = [];
                for (let updatedStructureService of updatedStructure) {
                    if (updatedStructureService?.service?.parentId == item?.service?.parentId) {
                        count++
                    }
                }
                if (count == 1) {
                    let itemIndex = updatedStructure?.findIndex(serviceItem => serviceItem?.service?.id == item?.service?.id);
                    updatedStructure.splice(itemIndex, 1);
                    let parentIndex = updatedStructure?.findIndex(serviceItem => serviceItem?.service?.id == item?.service?.parentId);
                    updatedStructure.splice(parentIndex, 1);
                    let mainParentIndex = updatedStructure?.findIndex(serviceItem => serviceItem?.service?.id == service?.firstParentId);
                    updatedStructure.splice(mainParentIndex, 1);
                }
                else {
                    let index = updatedStructure?.findIndex(serviceItem => serviceItem?.service?.id == item?.service?.id);
                    updatedStructure.splice(index, 1)
                }
            }
        }
        setPreserveStructure(updatedStructure);
        setIsDisabled(false)
    };

    // a function to render subServices in a children property of Collapse component.
    const renderSubServices = (service) => {
        return service?.subServices?.map((subService, index) => {
            return (
                <div className='mb-4 mr-6' key={index}>
                    <Row className='mb-2' justify={'space-between'} key={index}>
                        <Col><span>{subService?.name}</span></Col>
                        <Col className='flex items-center gap-3'>
                            <Checkbox
                                indeterminate={
                                    selectedServices[service?.firstParentId]?.length > 0 &&
                                    selectedServices[service?.firstParentId]?.length < subService?.subServices?.length &&
                                    subService?.subServices?.some(sub => selectedServices[service?.firstParentId]?.includes(sub.id))
                                }
                                disabled={subService?.subServices?.length == 0 ? true : false}
                                checked={
                                    subService?.subServices?.length !== 0 &&
                                    subService?.subServices?.every(sub => selectedServices[service?.firstParentId]?.includes(sub.id))
                                }
                                onChange={(e) => handleCheckAll(service?.firstParentId, subService, e.target.checked)}
                            >
                                Select All
                            </Checkbox>
                        </Col>
                    </Row>

                    <div className={`bg-[#f1f6fa] rounded-md p-2 w-full`}>
                        <Checkbox.Group className='w-full' value={selectedServices[service?.firstParentId]}>
                            <Row justify={'space-between'}>
                                {
                                    subService?.subServices?.length > 0 ?
                                        subService?.subServices?.map((thirdLayerSubService, index) => {
                                            return (
                                                <Col lg={7} className='flex gap-3 items-center mb-3 services-checkboxes' key={index}>
                                                    <Checkbox
                                                        value={thirdLayerSubService?.id}
                                                        onChange={(e) =>
                                                            handleSubServiceCheck(service, thirdLayerSubService, subService, e.target.checked)}
                                                    >
                                                        {thirdLayerSubService?.name}
                                                        {/* <span className='ml-1 font-semibold'>(£ {thirdLayerSubService?.percentage})</span> */}
                                                    </Checkbox>
                                                </Col>
                                            )
                                        })
                                        :
                                        <p className='text-gray-400 text-sm'>No sub service available</p>
                                }
                            </Row>
                        </Checkbox.Group>
                    </div>
                </div>
            )
        })
    }

    // items to render in collapse
    const items = allServices?.map((service, index) => {
        console.log("subService:", service)
        return (
            {
                key: service?.firstParentId,
                label: <div className='flex justify-between'><span>{service?.name}</span></div>,
                children: (
                    <div key={index} className='h-28 overflow-y-auto'>
                        {renderSubServices(service)}
                    </div>
                ),
            }
        )
    })

    const collapseHandler = (activeKey) => {
        let previousActiveKeys = defaultActiveCollapseKeys;
        if (typeof activeKey == 'object') {
            if (previousActiveKeys?.length < activeKey?.length) {
                let lastElement = activeKey[activeKey.length - 1];
                let extraDetails = selectedService?.find(item => item?.id == lastElement);
                if (extraDetails?.isDetailsRequired && activeKey) {
                    let extraDetailModalCloneData = { ...extraDetailModal.data };
                    if (!extraDetailModalCloneData.hasOwnProperty(lastElement)) {
                        setCurrentActiveCollapseKey(lastElement);
                        setExtraDetailModal((prev) => ({
                            ...prev, show: true, data: {
                                ...prev.data, [lastElement]: {
                                    cars: false,
                                    vans: false,
                                    price: ""
                                }
                            }
                        }))
                    }
                    else {
                        setCurrentActiveCollapseKey(lastElement);
                        setExtraDetailModal((prev) => ({ ...prev, show: true }))
                    }
                } else {
                    setExtraDetailModal((prev) => ({ ...prev, show: false }))
                }
            } else {
                setExtraDetailModal((prev) => ({ ...prev, show: false }))
            }
        }
        else {
            let extraDetails = selectedService.find(item => item?.id == activeKey);
            if (extraDetails?.isDetailsRequired && activeKey) {
                let extraDetailModalCloneData = { ...extraDetailModal.data };
                if (!extraDetailModalCloneData.hasOwnProperty(activeKey)) {
                    setCurrentActiveCollapseKey(activeKey);
                    setExtraDetailModal((prev) => ({
                        ...prev, show: true, data: {
                            ...prev.data, [activeKey]: {
                                cars: false,
                                vans: false,
                                price: ""
                            }
                        }
                    }))
                }
                else {
                    setCurrentActiveCollapseKey(activeKey);
                    setExtraDetailModal((prev) => ({ ...prev, show: true }))
                }
            } else {
                setExtraDetailModal((prev) => ({ ...prev, show: false }))
            }
        }

        if (activeKey) {
            setDefaultActiveCollapseKeys(activeKey)
        }
    }


    const checkboxHandler = (e) => { }

    const businessInfoMutation = useMutation(async (data) => {
        let res = await ApiCaller.put('/user/update-business-service', data);
        return res
    },
        {
            onSuccess: (res) => {
                dispatch(setMessage(res?.data?.data?.message))
                setIsDisabled(true);
                // setDefaultActiveCollapseKeys(null)
                // setSelectedFinalServices({})
                // setSelectedServices({})
                dispatch(fetchProfileData())
                // navigate('/settings')
            },

            onError: (error) => {
                console.log(error)
                dispatch(setError(error?.response?.data?.error?.message))
            }
        }
    )

    const submitForm = () => {

        let cloneSelectedServices = { ...selectedServices };
        let cloneSelectedFinalServices = { ...selectedFinalServices };

        // error handling
        // let errorStatus = true;
        // for (let item in cloneSelectedFinalServices) {
        //     if (cloneSelectedFinalServices[item]?.length > 0) {
        //         errorStatus = false;
        //         break;
        //     }
        // }
        // setIsError(errorStatus)
        // if (errorStatus) return

        let services = [];

        for (const key in cloneSelectedFinalServices) {
            cloneSelectedFinalServices[key].forEach(item => {
                services.push({
                    serviceId: item.serviceId,
                    details: item.details || null
                });
            });
            cloneSelectedServices[key].forEach(serviceId => {
                if (!cloneSelectedFinalServices[key].find(item => item.serviceId === serviceId)) {
                    services.push({
                        serviceId: serviceId,
                        details: null
                    });
                }
            });
        }

        let myServices = [];
        const preserveServices = profileData?.userServices?.length > 0 ? [...profileData?.userServices] : [];

        // if preserveServices not exist that means its getting add first time.
        if (preserveServices?.length == 0) {
            myServices = services;
        }

        else {
            for (let choosenService of services) {
                if (choosenService?.serviceId == preserveServices.find(preserve => preserve?.service?.id)) {
                    myServices.push({
                        serviceId: choosenService?.serviceId,
                        details: null
                    })
                }
                else {
                    myServices.push({
                        serviceId: choosenService?.serviceId,
                        details: null
                    })
                }
            }
            // appending the preserve services
            for (let preserveService of preserveStructure) {
                if (!services?.some(service => service?.serviceId == preserveService?.service?.id)) {
                    myServices.push({
                        serviceId: preserveService?.service?.id,
                        details: null
                    })
                }
            }
        }

        const payload = {
            services: myServices
        }

        businessInfoMutation.mutate(payload)
    }

    return (
        <>
            <TitleWithBackNavigation title={''} link={'/settings/businessInfo/services'} />
            <Row justify={'space-between'} className='my-4'>
                <Col lg={17} md={24} sm={24} xs={24} className='mb-2'>
                    <Collapse
                        activeKey={defaultActiveCollapseKeys}
                        items={items}
                        collapsible='icon'
                        onChange={collapseHandler}
                    // expandIcon={({ isActive }) => <Checkbox onChange={checkboxHandler} checked={isActive} />}
                    />
                    {isError && <p className='mt-2 text-red-500'>Services is required</p>}
                </Col>
            </Row>
            <Row className='ml-1'>
                <Button
                    onClick={() => submitForm()}
                    loading={businessInfoMutation.isLoading}
                    htmlType='submit'
                    disabled={isDisabled}
                    className='w-36 h-10 mt-3 rounded-md outline-none border-none'
                    style={{ background: Colors.AppYellow, color: 'white' }}>
                    Save
                </Button>
            </Row>


            {/* currrently not working */}
            {/* {
                extraDetailModal?.show &&
                <Modal
                    open={extraDetailModal?.show}
                    onCancel={() => setExtraDetailModal((prev) => ({ ...prev, show: false }))}
                    okButtonProps={false}
                    footer={false}
                    width={300}
                    centered
                >
                    <Row className='px-8 py-6 flex flex-col gap-4'>
                        <p className='w-full text-center font-semibold text-lg'>Mot Test Centers</p>
                        <Col lg={24} className='flex flex-col items-start gap-2'>
                            <div>
                                <Checkbox className='text-base'
                                    onChange={(e) => setExtraDetailModal((prev) =>
                                    ({
                                        ...prev, data: {
                                            ...prev.data,
                                            [currentActiveCollapseKey]: { ...prev?.data[currentActiveCollapseKey], cars: e.target.checked }
                                        }
                                        , error: { ...prev.error, checkboxError: '' }
                                    }))}
                                    value={extraDetailModal?.data?.[currentActiveCollapseKey]?.cars}
                                    defaultChecked={extraDetailModal?.data?.[currentActiveCollapseKey]?.cars}
                                >
                                    Cars
                                </Checkbox>
                                <Checkbox className='text-base'
                                    onChange={(e) => setExtraDetailModal((prev) =>
                                    ({
                                        ...prev, data: {
                                            ...prev.data,
                                            [currentActiveCollapseKey]: { ...prev?.data[currentActiveCollapseKey], vans: e.target.checked }
                                        }
                                        , error: { ...prev.error, checkboxError: '' }
                                    }))}
                                    value={extraDetailModal?.data?.[currentActiveCollapseKey]?.vans}
                                    defaultChecked={extraDetailModal?.data?.[currentActiveCollapseKey]?.vans}
                                >
                                    Vans
                                </Checkbox>
                            </div>
                            {extraDetailModal.error.checkboxError && <p className='text-red-500'>{extraDetailModal.error.checkboxError}</p>}
                        </Col>
                        <Col>
                            <div>
                                <label>Add Price:</label>
                                <Input
                                    style={{ boxShadow: '0px 3px 6px #0000001A' }}
                                    onChange={(e) => setExtraDetailModal((prev) =>
                                    ({
                                        ...prev, data: {
                                            ...prev.data,
                                            [currentActiveCollapseKey]: { ...prev?.data[currentActiveCollapseKey], price: e.target.value }
                                        }
                                        , error: { ...prev.error, checkboxError: '' }
                                    }))}
                                    value={extraDetailModal?.data?.[currentActiveCollapseKey]?.price}
                                />
                            </div>
                            {extraDetailModal.error.priceError && <p className='text-red-500'>{extraDetailModal.error.priceError}</p>}
                        </Col>
                        <Button onClick={motSubmitHandler} className='h-10 rounded-md outline-none border-none w-full' style={{ background: Colors.AppYellow, color: 'white' }}>
                            Save
                        </Button>
                    </Row>
                </Modal>
            } */}
        </>
    )
}

export default AddServices